(() => {
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];
  const toast = (msg) => { const t=$('.gn-toast'); if(!t)return; t.textContent=msg; t.classList.add('is-active'); setTimeout(()=>t.classList.remove('is-active'),2200); };

  document.addEventListener('click', async (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      const id = quick.dataset.productId;
      if(!id) return;
      quick.disabled=true; quick.textContent='Adding…';
      try {
        const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
        if(!r.ok) throw new Error();
        await refreshCart(); openCart(); toast('Added to cart');
      } catch(err) { toast('Please select options first'); }
      finally { quick.disabled=false; quick.textContent='Quick add'; }
    }
    if(e.target.closest('[data-cart-open]')) openCart();
    if(e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) closeCart();
    const wish=e.target.closest('[data-wishlist]');
    if(wish){ wish.classList.toggle('is-saved'); wish.textContent=wish.classList.contains('is-saved')?'♥':'♡'; toast(wish.classList.contains('is-saved')?'Saved to wishlist':'Removed from wishlist'); }
    if(e.target.closest('.gn-mobile-toggle')){
      const b=e.target.closest('.gn-mobile-toggle'); const nav=$('[data-mobile-nav]');
      nav.classList.toggle('is-open'); b.setAttribute('aria-expanded',nav.classList.contains('is-open'));
    }
    if(e.target.closest('[data-qty-minus]') || e.target.closest('[data-qty-plus]')){
      const row=e.target.closest('.gn-qty'), input=$('input',row); let n=Math.max(1,Number(input.value)||1);
      n += e.target.closest('[data-qty-plus]') ? 1 : -1; input.value=n;
    }
    const thumb=e.target.closest('[data-gallery-thumb]');
    if(thumb){ const i=thumb.dataset.galleryThumb; $$('.gn-main-media').forEach(x=>x.classList.toggle('is-hidden',x.dataset.galleryMedia!==i)); $$('.gn-thumb').forEach(x=>x.classList.toggle('is-active',x===thumb)); }
  });

  async function refreshCart(){
    try{
      const r=await fetch('/cart.js'); const cart=await r.json();
      $$('.gn-cart-count').forEach(x=>x.textContent=cart.item_count);
      const body=$('[data-cart-body]');
      if(body) body.innerHTML=cart.item_count ? cart.items.map(i=>`<div class="gn-cart-line"><div>${i.product_title}</div><div>${i.quantity} × ${(i.final_line_price/100).toLocaleString('en-PK',{style:'currency',currency:'PKR'})}</div></div>`).join('') : '<div class="gn-empty">Your cart is empty.</div>';
      const total=$('[data-cart-total]'); if(total) total.textContent=(cart.total_price/100).toLocaleString('en-PK',{style:'currency',currency:'PKR'});
    }catch(e){}
  }
  function openCart(){ const d=$('[data-cart-drawer]'); if(d){d.classList.add('is-open');d.setAttribute('aria-hidden','false');$('.gn-drawer-overlay')?.classList.add('is-open');}}
  function closeCart(){ const d=$('[data-cart-drawer]'); if(d){d.classList.remove('is-open');d.setAttribute('aria-hidden','true');$('.gn-drawer-overlay')?.classList.remove('is-open');}}

  const form=$('#product-form');
  if(form) form.addEventListener('submit',async e=>{
    e.preventDefault();
    const btn=$('.gn-add',form); btn.disabled=true; btn.textContent='Adding…';
    try{
      const fd=new FormData(form);
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
      if(!r.ok) throw new Error(); await refreshCart(); openCart(); toast('Added to cart');
    }catch(err){toast('Could not add to cart');}
    finally{btn.disabled=false;btn.textContent='Add to cart';}
  });
})();